import { TranslateService } from '@ngx-translate/core';

/**
 * Arma el título de un formulario de mantenimiento componiendo la acción con el
 * nombre de la entidad, que es la convención del diccionario: en lugar de una
 * key por frase ("Nuevo Rol", "Editar Rol"), se reusan COMMON.ACTIONS.NEW /
 * NEW_F / EDIT más la etiqueta de la entidad.
 *
 * Ojo con el género en español: COMMON.ACTIONS.NEW vale "Nuevo" y solo sirve
 * para entidades masculinas (Rol, Módulo, Grupo). Para las femeninas (Empresa,
 * Categoría, Unidad) hay que pasar 'NEW_F', que vale "Nueva". En inglés ambas
 * keys valen "New", así que la distinción no se nota.
 *
 * @param translate Servicio de traducción del componente
 * @param accion 'NEW' para crear (masculino), 'NEW_F' para crear (femenino), 'EDIT' para editar, 'VISUALIZE' para solo lectura
 * @param entidadKey Key de la etiqueta de la entidad (por ejemplo COMMON.LABEL.ROLE)
 */
export function composeTitle(
  translate: TranslateService,
  accion: 'NEW' | 'NEW_F' | 'EDIT' | 'VISUALIZE',
  entidadKey: string
): string {
  const verbo = translate.instant(`COMMON.ACTIONS.${accion}`);
  const entidad = translate.instant(entidadKey);
  return `${verbo} ${entidad}`;
}
